module.exports = __webpack_public_path__ + "img/delivery.73928ee.png";